import { createSlice } from "@reduxjs/toolkit";
import {
  checkShouldShowReminderThunk,
  dismissReminderThunk
} from "./tripBackupReminderActions";

export interface ITripBackupReminderState {
  loading: boolean;
  shouldShow: boolean;
  error: string | null;
  lastDismissedAt: string | null;
  lastDownloadedAt: string | null;
}

const initialState: ITripBackupReminderState = {
  loading: false,
  shouldShow: false,
  error: null,
  lastDismissedAt: null,
  lastDownloadedAt: null
};

const tripBackupReminderSlice = createSlice({
  name: "tripBackupReminder",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(checkShouldShowReminderThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(checkShouldShowReminderThunk.fulfilled, (state, action) => {
        state.loading = false;

        // Handle both boolean and object responses
        if (typeof action.payload === "boolean") {
          state.shouldShow = action.payload;
          state.lastDismissedAt = null;
          state.lastDownloadedAt = null;
        } else {
          state.shouldShow = action.payload?.shouldShow ?? false;
          state.lastDismissedAt = action.payload?.lastDismissedAt ?? null;
          state.lastDownloadedAt = action.payload?.lastDownloadedAt ?? null;
        }

        state.error = null;
      })
      .addCase(checkShouldShowReminderThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Error checking reminder status";
        state.shouldShow = false;
      })
      .addCase(dismissReminderThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(dismissReminderThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.shouldShow = false;
        state.lastDismissedAt = action.payload?.dismissedAt ?? null;
        state.error = null;
      })
      .addCase(dismissReminderThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Error dismissing reminder";
      });
  }
});

export default tripBackupReminderSlice.reducer;
